module.exports = __webpack_public_path__ + "image/article_related_zw.jpg";